import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import About from './pages/About';
import Menu from './pages/Menu';
import Gallery from './pages/Gallery';
import Reserve from './pages/Reserve';
import Contact from './pages/Contact';
import AdminLogin from './admin/AdminLogin';
import AdminLayout from './admin/AdminLayout';
import AdminDashboard from './admin/AdminDashboard';
import AdminUsers from './admin/AdminUsers';
import AdminPages from './admin/AdminPages';
import AdminMenu from './admin/AdminMenu';
import AdminGallery from './admin/AdminGallery';
import AdminTestimonials from './admin/AdminTestimonials';
import AdminSettings from './admin/AdminSettings';
import './assets/css/App.css';
import './assets/css/Responsive.css';

function App() {
  return (
    <div 
      className="app-wrapper"
      style={{
        minHeight: '100vh',
        position: 'relative'
      }}
    >
      <div 
        className="pattern-overlay"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: 'url(/yamas%20pattern.png)',
          backgroundRepeat: 'fixed',
          backgroundSize: 'auto',
          backgroundPosition: '0 0',
          zIndex: -2,
          pointerEvents: 'none'
        }}
      />
      <div 
        className="white-overlay"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(255, 255, 255, 0.9)',
          zIndex: -1,
          pointerEvents: 'none'
        }}
      />
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={
          <>
            <Navigation />
            <Home />
          </>
        } />
        <Route path="/about" element={
          <>
            <Navigation />
            <About />
          </>
        } />
        <Route path="/menu" element={
          <>
            <Navigation />
            <Menu />
          </>
        } />
        <Route path="/gallery" element={
          <>
            <Navigation />
            <Gallery />
          </>
        } />
        <Route path="/reserve" element={
          <>
            <Navigation />
            <Reserve />
          </>
        } />
        <Route path="/contact" element={
          <>
            <Navigation />
            <Contact />
          </>
        } />
        
        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }>
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="pages" element={<AdminPages />} />
          <Route path="menu" element={<AdminMenu />} />
          <Route path="gallery" element={<AdminGallery />} />
          <Route path="testimonials" element={<AdminTestimonials />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>
      </Routes>
    </Router>
    </div>
  );
}

export default App;
